import BaseModelComponent from '../../base/base_model_component';
import _ from '../../utils/underscore';
import ServiceFactory from '../../services/service_factory';

const historyTitle = require('./view/title.html');
const historyDropdown = require('./view/dropdown.html');

class HistoryModel extends BaseModelComponent {
    /**
     *
     * @param params
     */
    init(params) {
        if (params && !this._showTitle) { // prevent override show title parameter
            this._setIsShowTitle(params.showTitle);
        }
        if (params && !this._showDropdown) { // prevent override show dropdown parameter
            this._setIsShowDropdown(params.showDropdown);
        }

        if (params && params.PagingData && params.GameHistoryData) {
            this.logger.debug('History length', params.GameHistoryData.length);

            this
                ._createPromise()
                ._setPagingData(params.PagingData)
                ._setGameHistoryData(params.GameHistoryData)
                ._setIsLastPage(params.isLastPage)
                ._buildGameSessions();
        }
    }


    getPromiseModel() {
        return this._promise;
    }

    getPaging() {
        return this._paging;
    }

    getHistory() {
        return this._history;
    }


    /**
     * xxxxx
     *
     * @param
     * @private
     */
    _createPromise() {
        this._promise = new Promise((resolve, reject)=> {
            this._promiseResolve = resolve;
            this._promiseReject = reject;
        });

        return this;
    }

    /**
     * xxxxx
     *
     * @param
     * @private
     */
    _setPagingData(pagingData) {
        this._paging = pagingData;

        return this;
    }

    /**
     * xxxxx
     *
     * @param
     * @private
     */
    _setGameHistoryData(gameHistoryData) {
        this._history = gameHistoryData;

        return this;
    }


    /**
     *
     * @param isLastPage
     * @returns {HistoryModel}
     * @private
     */
    _setIsLastPage(isLastPage) {
        this._isLastPage = isLastPage;
        return this;
    }


    /**
     * Set if title will be shown
     * @param showTitle
     * @returns {HistoryModel}
     * @private
     */
    _setIsShowTitle(showTitle = true) {
        this._showTitle = _.toBoolean(showTitle);
        return this;
    }

    /**
     * Set if dropdown will be shown
     * @param showTitle
     * @returns {HistoryModel}
     * @private
     */
    _setIsShowDropdown(showDropdown = false) {
        this._showDropdown = _.toBoolean(showDropdown);
        return this;
    }

    /**
     * xxxxx
     *
     * @param
     * @private
     */
    _buildGameSessions() {
        const sessions = this._history.map(h => h.GameTypeId);

        if (0 === sessions.length) {
            this.logger.debug('No have any open sessions to display.');
            this._promiseReject();
            return this;
        }
        ServiceFactory.create().gamesInformationService().getGamesInfoWithoutAnyFiltering(sessions)
            .then(openSessionOptions => {
                if (!_.isObject(openSessionOptions) || 0 === Object.keys(openSessionOptions).length) {
                    this.logger.debug('integration host return empty open sessions.');
                    return;
                }

                this.logger.debug('Getting Information about each game history. History length:', this._history.length);

                this._history.forEach(history => {
                    let translatedGameSession = openSessionOptions[history.GameTypeId];

                    history.gameSession = translatedGameSession;
                });

                this._promiseResolve(this._history);
            })
            .catch((error) => {
                if (!error) {
                    this.logger.error('Unexpected exception');
                    throw new Error();
                }

                this.logger.error('Error in getting open session reason => ', error.error);

                throw Error('Could not create open session because => ' + error.error);
            });

        return this;
    }


    /**
     * Get history las history data
     *
     * @returns {{GameHistoryData: *, isLastPage: *}}
     */
    getHistoryData() {
        return {GameHistoryData: this._history, isLastPage: this._isLastPage};
    }

    getShowTitle() {
        return this._showTitle ? historyTitle : '';
    }

    getShowDropdown() {
        return this._showDropdown ? historyDropdown : '';
    }
}

export default HistoryModel;